module.exports = __webpack_public_path__ + "img/5_42.54de89a1.png";